// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RightCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/RightCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var RightCircleOutlined = function RightCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RightCircleOutlinedSvg
  }));
};

RightCircleOutlined.displayName = 'RightCircleOutlined';
export default React.forwardRef(RightCircleOutlined);